import { z } from "zod";

export const institutionNumber = () =>
  z
    .string()
    .length(3, { message: "Institution number must be exactly 3 digits long" });
